// src/pages/LowResult.js
import React, { useState } from "react";
import { useLocation, Link } from "react-router-dom";
import {
  calculateEarningRange,
  computeTopPercentile,
  getDescription,
} from "../utils";
import "./Result.css";

function LowResult() {
  const [toastVisible, setToastVisible] = useState(false);
  const [toastMessage, setToastMessage] = useState("");

    // (1) 축약 함수
    function abbreviateNumber(num) {
      if (num < 1000) return num.toString();
      else if (num < 1_000_000)
        return (num / 1000).toFixed(1).replace(/\.0$/, "") + "K";
      else if (num < 1_000_000_000)
        return (num / 1_000_000).toFixed(1).replace(/\.0$/, "") + "M";
      return (num / 1_000_000_000).toFixed(1).replace(/\.0$/, "") + "B";
    }

  const { state } = useLocation();
  if (!state) {
    return (
      <div>
        Oh no! An error has occurred. Please try again. <Link to="/">Home</Link>
      </div>
    );
  }

  const { instagramId, followerCount, category, recentCollabs, campaignCost } =
    state;
  const topPercentile = computeTopPercentile(followerCount, category);
  const { minEarning, midEarning, maxEarning } = calculateEarningRange(
    followerCount,
    category,
    recentCollabs,
    campaignCost
  );
  const { title, description, image } = getDescription(topPercentile);

  // 토스트
  const showToast = (msg) => {
    setToastMessage(msg);
    setToastVisible(true);
    setTimeout(() => setToastVisible(false), 2000);
  };

  // fallback copy
  const handleCopyLink = async () => {
    const copyText = "https://beautyscouter.simpleseed.ai";
    try {
      if (navigator.clipboard && navigator.clipboard.writeText) {
        await navigator.clipboard.writeText(copyText);
      } else {
        const tempInput = document.createElement("textarea");
        tempInput.value = copyText;
        document.body.appendChild(tempInput);
        tempInput.select();
        document.execCommand("copy");
        document.body.removeChild(tempInput);
      }
      showToast("Link has been copied!");
    } catch (err) {
      console.error("copy link error:", err);
      alert("An error occurred. Check console.");
    }
  };

  return (
    <div className="result-container">
      {toastVisible && <div className="toast-message">{toastMessage}</div>}

      {/* (1) Header */}
      <header className="result-header">
        <a
            href="../"
            target="_self"
            rel="noreferrer">
        <img
          src="https://beauty-scouter.s3.us-east-2.amazonaws.com/logo.svg"
          alt="SimpleSeed"
          className="logo"
        />
        </a>
        <button className="result-share-btn" onClick={handleCopyLink}>
          <img
            src="https://beauty-scouter.s3.us-east-2.amazonaws.com/share-orange.svg"
            alt="Share"
            className="result-share-icon"
          />
        </button>
      </header>

      {/* (2) Top% + influencer */}
      <section className="top-section">
        <div className="top-box">
          <div className="top-badge">
            <img
              src="https://beauty-scouter.s3.us-east-2.amazonaws.com/Star.svg"
              alt="star"
              className="star-icon"
            />
            Top {topPercentile}%
          </div>
          <div className="influencer-inner">
            <div className="handle-pill">@{instagramId}</div>
            <div className="info-row">
              <div className="info-block">
                <img
                  src="https://beauty-scouter.s3.us-east-2.amazonaws.com/Follower-orange.svg"
                  alt="Follower"
                />
                <span className="followers-text">Followers</span>
                <span className="followers">
                  {abbreviateNumber(followerCount)}
                </span>
              </div>
              <div className="info-block">
                <img
                  src="https://beauty-scouter.s3.us-east-2.amazonaws.com/Category-orange.svg"
                  alt="Category"
                />
                <span className="category-text">{category}</span>
                <span className="category">Influencer</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* (3) Orange box */}
      <section className="scout-box">
        <h2 className="scout-text">Your Beauty Score Has Been Scouted!</h2>
        <div className="earning-range">
          ${minEarning.toLocaleString()} ~ ${maxEarning.toLocaleString()}
          <span className="per-year">/year</span>
        </div>
        <div className="earning-sub">Estimated earnings on SimpleSeed</div>
      </section>

      {/* (4) Scouter Review (Low) */}
      <section className="review-wrap">
        <h3 className="review-title">Scouter’s Review</h3>
        {image ? (
          <img src={image} alt={title} className="review-image" />
        ) : (
          <div className="review-image-fallback" />
        )}
        <h4 className="review-grade">{title || "Courageous Starter"}</h4>
        <p className="review-desc">
          {description ||
            "You’re just getting started, but every great story starts somewhere. Keep moving—you might just turn heads sooner than you think."}
        </p>
      </section>

      {/* (5) Encouragement */}
      <section className="invite-section">
        <img
          className="invite-bg"
          src="https://beauty-scouter.s3.us-east-2.amazonaws.com/gradient.png"
          alt="BG"
        />
        <div className="invite-box">
          <img
            src="https://beauty-scouter.s3.us-east-2.amazonaws.com/(.svg"
            alt="("
          />
          <div>
            <p className="invite-low">
              SimpleSeed is cheering you on to become an even
            </p>
            <p className="invite-low-serif">greater beauty influencer!</p>
          </div>
          <img
            src="https://beauty-scouter.s3.us-east-2.amazonaws.com/).svg"
            alt=")"
          />
        </div>
      </section>

      {/* (6) Additional text */}
      <p className="collaborate-low-text">
        As your Beauty Power grows, <br />
        we’ll be the <span className="collaborate-low-italic">first to reach out.</span>
      </p>

      {/* (7) Download box */}
      <section className="download-box">
        <h4 className="download-heading">
          Download <span>SimpleSeed</span>
        </h4>
        <div className="store-buttons">
          <a
            href="https://apps.apple.com/us/app/simpleseed-for-influencers/id6739995046"
            target="_blank"
            rel="noreferrer"
          >
            <img
              src="https://beauty-scouter.s3.us-east-2.amazonaws.com/apple.svg"
              alt="App Store"
              className="store-img"
            />
          </a>
          <a
            href="https://play.google.com/store/apps/details?id=com.wear.simpleseed"
            target="_blank"
            rel="noreferrer"
          >
            <img
              src="https://beauty-scouter.s3.us-east-2.amazonaws.com/google.svg"
              alt="Google Play"
              className="store-img"
            />
          </a>
        </div>
      </section>

      {/* (8) Share */}
      <section className="share-section">
        <div className="share-box">
          <img
            className="share-icon"
            src="https://beauty-scouter.s3.us-east-2.amazonaws.com/share-orange.svg"
            alt="Share"
          />
          <h4>Share</h4>
        </div>
        <button className="copy-btn" onClick={handleCopyLink}>
          <img
            className="copy-icon"
            src="https://beauty-scouter.s3.us-east-2.amazonaws.com/copy-orange.svg"
            alt="Copy"
          />
          Copy Link
        </button>
      </section>

      {/* (9) Disclaimer */}
      <section className="disclaimer">
        <p className="disclaimer-title">Disclaimer</p>
        <p className="disclaimer">
          All figures shown are estimates and may not reflect actual results.
        </p>
      </section>

      {/* (10) Footer */}
      <footer className="result-footer">
        <div className="footer-line" />
        <div className="footer-content">
          <div>
            <img
              className="footer-logo"
              src="https://beauty-scouter.s3.us-east-2.amazonaws.com/logo.svg"
              alt="Footer Logo"
            />
          </div>
          <div className="footer-icons">
            <a
              href="https://www.instagram.com/simpleseed/"
              target="_blank"
              rel="noreferrer"
            >
              <img
                src="https://beauty-scouter.s3.us-east-2.amazonaws.com/IG-orange.svg"
                alt="Instagram"
                className="footer-icon"
              />
            </a>
            <a
              href="https://simpleseed.ai/"
              target="_blank"
              rel="noreferrer"
            >
              <img
                src="https://beauty-scouter.s3.us-east-2.amazonaws.com/Home.svg"
                alt="Home"
                className="footer-icon"
              />
            </a>
          </div>
        </div>
      </footer>
    </div>
  );
}

export default LowResult;